import "./styles/aplicacion.css";
import "./styles/pwa.css";
import { rec_iniciarAplicacion as iniciarAplicacion } from "./runtime/index.jsx";
iniciarAplicacion();
